import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { FiHeart, FiMapPin } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css"; 
import axios from "axios";
import { baseurl } from "../../baseurl";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import PageCount from "../../component/utils/PageCount";

function Terms() {
   
  return (
    <section className=" container py-5">

        <PageCount pageName = {"Terms"}/>
       <header>
        <h1>&#9989; Terms and Conditions of Service for Soulsathi.com</h1>
        <p><strong>Effective Date:</strong> November 27, 2025</p>
    </header>

    <p>Welcome to Soulsathi.com! These Terms and Conditions ("Terms") govern your use of the Soulsathi.com mobile application and website (collectively, the "Services"). By accessing or using the Services, you agree to be bound by these Terms.</p>

    <hr/>

    <section>
        <h4>1. Acceptance of Terms</h4>
        <p>By clicking "Accept" or by using the Services, you affirm that you are of legal marriageable age in your jurisdiction and that you have read, understood, and agree to be bound by these Terms, along with our Privacy Policy.</p>
    </section>

    <hr/>

    <section>
        <h4>2. Eligibility and Account</h4>
        <ul>
            <li><strong>Eligibility:</strong> You must meet the legal age requirement for marriage in your country (generally 18 years or older) to create an account. You must also be legally single or divorced.</li>
            <li><strong>Account Responsibility:</strong> You are responsible for maintaining the confidentiality of your account login information and for all activities that occur under your account.</li>
            <li><strong>Truthfulness:</strong> You agree that all information you provide is true, accurate, current, and complete. Misrepresenting your identity, marital status, or profile details is strictly prohibited and grounds for immediate termination.</li>
        </ul>
    </section>

    <hr/>

    <section>
        <h4>3. User Data, Marketing, and Communication</h4>
        <h5>A. Use of User Data</h5>
        <p>By creating an account, you acknowledge and agree that [Application Name] reserves the right to use your provided data, including profile information, usage data, and contact details, for the following purposes:</p>
        <ul>
            <li>To display your profile for matchmaking purposes.</li>
            <li>To improve and analyze the Services.</li>
            <li><strong>To send marketing campaigns, promotional materials, special offers, and communications related to [Application Name] or its partners via email, SMS, push notifications, or in-app messaging. You may opt-out of marketing communications as detailed in the Privacy Policy.</strong></li>
        </ul>

        <h5>B. Content License</h5>
        <p>You grant [Application Name] a worldwide, non-exclusive, royalty-free license to use, reproduce, distribute, and display the content (photos, text, videos) you upload to the Services solely for the purpose of operating, promoting, and improving the Services.</p>
    </section>

    <hr/>

    <section>
        <h4>4. User Conduct and Misconduct Disclaimer</h4>
        <h5>A. Prohibited Conduct</h5>
        <p>You agree not to use the Services for any unlawful purpose or in any way that could damage the reputation of [Application Name] or other users. Prohibited activities include, but are not limited to:</p>
        <ul>
            <li>Harassment, stalking, abuse, or sending unsolicited communication (spam) to other users.</li>
            <li>Uploading or sharing obscene, violent, or copyrighted material without permission.</li>
            <li>Engaging in financial fraud, requesting money, or selling goods/services.</li>
            <li>Attempting to collect personal data of other users for non-matrimonial purposes.</li>
        </ul>

        <h5>B. Responsibility and Disclaimer</h5>
        <p><strong>[Application Name] is a platform facilitating connections and cannot and does not guarantee the identity, intentions, background, or conduct of its users. You are solely responsible for your interactions with other users, both on and off the Services.</strong></p>
        <p><strong>The Company is NOT responsible for any misconduct, misbehavior, criminal act, or damages (including but not limited to emotional distress, financial loss, or personal harm) caused by any user of the platform. You agree to use caution and exercise personal safety judgment in all interactions. Any claim or grievance resulting from an interaction with another user is between you and the other user, and you agree to release [Application Name] from any liability related to such conduct.</strong></p>
    </section>

    <hr/>

    <section>
        <h4>5. Fees and Payment</h4>
        <p>Access to certain features of the Services may require a paid subscription or feature purchase ("Premium Services").</p>
        <ul>
            <li><strong>Billing:</strong> Fees are non-refundable unless explicitly stated otherwise by law or in a separate written agreement.</li>
            <li><strong>Renewal:</strong> Subscriptions may auto-renew, and you authorize us (or our third-party payment processor) to charge the applicable fee.</li>
        </ul>
    </section>

    <hr/>

    <section>
        <h4>6. Termination</h4>
        <p>We may terminate or suspend your access to the Services immediately, without prior notice or liability, for any reason whatsoever, including, without limitation, if you breach the Terms or engage in misconduct.</p>
    </section>

    <hr/>

    <section>
        <h4>7. Limitation of Liability and Indemnity</h4>
        <ul>
            <li><strong>Limitation of Liability:</strong> To the maximum extent permitted by applicable law, in no event shall [Application Name] be liable for any indirect, punitive, incidental, special, consequential, or exemplary damages, including without limitation damages for loss of profits, goodwill, data, or other intangible losses, resulting from your use of the Services.</li>
            <li><strong>Indemnity:</strong> You agree to indemnify and hold harmless [Application Name], its affiliates, officers, directors, employees, and agents from and against any claims, damages, obligations, losses, liabilities, costs, or debt arising from: (i) your use of and access to the Service; (ii) your violation of any term of these Terms; (iii) your violation of any third-party right, including without limitation any privacy or intellectual property right; or (iv) <strong>any claim arising from an interaction or communication with another user of the Services.</strong></li>
        </ul>
    </section>

    <hr/>

    <section>
        <h4>8. Governing Law and Jurisdiction</h4>
        <p>These Terms shall be governed and construed in accordance with the laws of [Insert Governing Jurisdiction, e.g., India or State/Country of Incorporation], without regard to its conflict of law provisions.</p>
    </section>

    <hr/>

    <section>
        <h4>9. Changes to Terms</h4>
        <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will notify you of material changes by posting the updated Terms on the Services.</p>
    </section>

    <hr/>

    <section>
        <h4>10. Contact Information</h4>
        <p>If you have any questions about these Terms, please contact us at:</p>
        <p><strong>Email:</strong> soulsathi.marketing@gmail.com</p>
    </section>
    </section>
  );
}

export default Terms;
